module.exports = __webpack_public_path__ + "img/jiQiRen5.b202300b.png";